import React from 'react';
import { AlertTriangle, Megaphone } from 'lucide-react';
import { useActiveNotices } from '../../hooks/useActiveNotices';

export function NoticeModal() {
  const { current, resolve } = useActiveNotices();
  if (!current) return null;

  const isNotice = current.type === 'notice';
  const isPersistent = current.behavior === 'persistent_version';

  const handlePrimaryAction = () => {
    if (current.cta_url) window.open(current.cta_url, '_blank', 'noopener');
    resolve(current);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="w-full max-w-sm rounded-2xl bg-white overflow-hidden shadow-2xl">
        <div className={isNotice ? 'h-1.5 bg-amber-500' : 'h-1.5 bg-indigo-500'} />
        <div className="p-5">
          <div className="flex items-center gap-2 mb-3">
            {isNotice ? (
              <AlertTriangle className="w-5 h-5 text-amber-500" />
            ) : (
              <Megaphone className="w-5 h-5 text-indigo-500" />
            )}
            <span
              className={
                isNotice
                  ? 'text-xs font-semibold uppercase tracking-wide text-amber-600'
                  : 'text-xs font-semibold uppercase tracking-wide text-indigo-600'
              }
            >
              {isNotice ? 'Notice' : 'Announcement'}
            </span>
          </div>

          <h2 className="text-lg font-bold text-slate-900 mb-1.5">{current.title}</h2>
          <p className="text-sm text-slate-600 mb-5 whitespace-pre-line">{current.body}</p>

          {current.behavior === 'acknowledge' && (
            <button
              onClick={() => resolve(current)}
              className="w-full py-2.5 rounded-xl bg-slate-900 text-white text-sm font-semibold active:scale-95 transition-transform"
            >
              Okay
            </button>
          )}

          {(current.behavior === 'link' || isPersistent) && (
            <button
              onClick={handlePrimaryAction}
              className={
                isNotice
                  ? 'w-full py-2.5 rounded-xl bg-amber-500 text-black text-sm font-semibold active:scale-95 transition-transform'
                  : 'w-full py-2.5 rounded-xl bg-indigo-500 text-white text-sm font-semibold active:scale-95 transition-transform'
              }
            >
              {current.cta_label ?? 'Okay'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}